import React, { FunctionComponent, MutableRefObject } from 'react';

import { useIntl } from 'react-intl';

import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Logo from './components/Logo';
import TextLogoWhite from './components/Logo/clubfinder-white';
import QuickloadImage from './components/QuickLoadImage';

import { useMediaQueryContext } from '../../providers/MediaQueryProvider';
import SecondaryButton from '../../components/atoms/SecondaryButton';

type SectionHeader = {
  aboutRef: MutableRefObject<null>;
  featuresRef: MutableRefObject<any>;
  feedbackRef: MutableRefObject<null>;
  appRef: MutableRefObject<null>;
};

const SectionHeader: FunctionComponent<SectionHeader> = ({
  aboutRef,
  featuresRef,
  feedbackRef,
  appRef,
}) => {
  const { formatMessage } = useIntl();

  return (
    <QuickloadImage
      src="assets/home.jpg"
      thumb="assets/home-small.jpg"
      alt="Club"
    >
      <Container maxWidth="lg" style={{ height: '100%' }}>
        <Box
          display="flex"
          justifyContent="space-between"
          flexDirection="column"
          m={1}
          height={1}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box>
              <Typography color="textSecondary" variant="h3">
                <TextLogoWhite />
              </Typography>
            </Box>

            <Box display="flex" alignItems="center">
              <Navigation
                sections={[
                  { title: 'about', ref: aboutRef },
                  { title: 'features', ref: featuresRef },
                  { title: 'feedback', ref: feedbackRef },
                ]}
              />
              <Box ml={2}>
                <SecondaryButton
                  onClick={() => scrollToRef(appRef)}
                  tabIndex={0}
                >
                  {formatMessage({ id: `hero.navigation.cta` })}
                </SecondaryButton>
              </Box>
            </Box>
          </Box>
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography color="textSecondary" variant="h1">
                  {formatMessage({ id: `hero.title` })}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography color="textSecondary" variant="body2">
                  <Logo /> {formatMessage({ id: `hero.subtitle` })}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </QuickloadImage>
  );
};

const scrollToRef = (ref: React.MutableRefObject<HTMLElement | null>) => {
  ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

type Navigation = {
  sections: {
    title: string;
    ref: React.MutableRefObject<HTMLElement | null>;
  }[];
};

const Navigation: FunctionComponent<Navigation> = ({ sections }) => {
  const size = useMediaQueryContext();
  const { formatMessage } = useIntl();

  if (size.width < 700) {
    return null;
  }

  return (
    <>
      {sections.map((section) => {
        return (
          <Box mx={2} key={section.title}>
            <Typography
              color="textSecondary"
              onClick={() => scrollToRef(section.ref)}
              style={{ cursor: 'pointer' }}
              variant="body2"
            >
              {formatMessage({ id: `hero.navigation.${section.title}` })}
            </Typography>
          </Box>
        );
      })}
    </>
  );
};

export default SectionHeader;
